import { IconNameEnum } from "../../../../components/Icon";
import { Tile } from "../../../../components/Tile";
import { Colors } from "../../../../utils/enums";

export interface IStringBannerProps {
  value: string;
  unit?: string;
  label: string;
  doesWeigh?: boolean;
}

export const DateBanner: React.FC<IStringBannerProps> = ({ label, value }) => {
  return (
    <>
      <Tile color={Colors.Border} icon={IconNameEnum.calendar} value={value} caption={label} valueFontSize="22px" />
    </>
  );
};
